
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/model/french",
      function () {
        return require("private-next-pages/model/french.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/model/french"])
      });
    }
  